import { LitElement, html, nothing } from "lit";

import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

import { SlotContentController } from "ui-common/slot-content-controller";
import { fieldWrapperStyles } from "./field-wrapper.css.ts";

@customElement("wow-field-wrapper")
export class WowFieldWrapper extends LitElement {
  static override styles = [fieldWrapperStyles];

  private labelSlot = new SlotContentController(this, "label");
  private helpSlot = new SlotContentController(this, "help");

  @property({ type: String }) inputType?: "radio" | "checkbox" | "switch";
  @property({ type: Boolean }) row = false;

  private get hasTitle(): boolean {
    return this.labelSlot.hasContent || this.helpSlot.hasContent;
  }

  override render() {
    return html`
      <div
        class=${classMap({
          "field-wrapper": true,
          [this.inputType as string]: !!this.inputType,
        })}
      >
        ${this.hasTitle
          ? html`
              <div class="title">
                <slot name="label"></slot>
                <slot name="help"></slot>
              </div>
            `
          : nothing}

        <div class="control"><slot name="control"></slot></div>

        <slot name="error"></slot>
      </div>
    `;
  }
}
